














































import { IProductCard } from "@/@types/menu/menu/menu";
import { ICart } from "@/@types/orders/new-order";
import { Component, Prop, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal } })
export default class BarOrderItem extends Vue {
  @Prop({ type: Object, default: null }) item!: ICart;
  @Prop({ type: Array, default: () => [] }) menu!: Array<IProductCard>;
  @Prop({ type: String, default: "" }) status!: string;
  @Prop({ type: String, default: "" }) server_name!: string;
  @Prop({ type: Number, default: 0 }) length!: number;

  get product(): IProductCard | null {
    const item = this.menu.find((m) => m._id == this.item.item_id);
    return item ? item : null;
  }

  get params(): string {
    if (this.server_name == "Server_Gallery") {
      const param = this.item.params
        ? `${this.item.item_id} / ${this.$getLocale(this.item.params.name)}`
        : "";

      return param;
    }
    return "";
  }

  get name(): string {
    return this.product
      ? this.$getLocale(this.product.name)
      : this.item.name
      ? this.$getLocale(this.item.name)
      : "-";
  }

  async changeCount(step: -1 | 1): Promise<void> {
    if (step == -1) {
      if (this.item.count == 0 || this.length == 1) {
        this.$bvModal.show("last-element-error");
        return;
      }
      if (this.item.count + step == 0) {
        try {
          const result = await this.$bvModal.msgBoxConfirm(
            String(this.$i18n.t("main.confirms.ok")),
            {
              title: String(this.$i18n.t("main.confirms.delete")),
            }
          );

          if (result !== true) return;
        } catch {
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("error.empty400")),
            type: "warn",
          });
        }
      }
    }
    this.$emit("changeCount", this.item.count + step);
  }

  async deleted(): Promise<void> {
    if (this.length == 1) {
      this.$bvModal.show("last-element-error");
      return;
    }
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
        }
      );

      if (result === true) {
        this.item.count = 0;
        this.$emit("changeCount", 0);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }
}
